import { Box } from "@chakra-ui/react";
import { useCurrencyFormatter } from "@reconvert/react-ui-component";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../app/hooks";
import { selectAppState } from "../../app/slice/appSlice";
import useConditions from "../../hooks/useConditions";
import Slots from "../CheckoutPage/components/Slots";
import MobileHeader from "./MobileHeader";
import { useCallback, useRef } from "react";
import ConditionCard from "../ConditionCard";
import { ConditionTextContainer } from "../CheckoutPage/components/Conditions";

const MobileSlotsScreen = () => {
  const { t } = useTranslation();
  const { selectedCondition, updateConditionStatus } = useConditions();
  const { storeInfo } = useAppSelector(selectAppState);
  const { currencyFormatter } = useCurrencyFormatter();

  const formatCurrency = useCallback(
    (value: number) => currencyFormatter(value, storeInfo?.currency!),
    [currencyFormatter, storeInfo?.currency],
  );

  const mouseRef = useRef(null);

  return (
    <Box h="100%" w="100%" bg="neutrals.200" display="flex" flexDirection="column" overflow="hidden">
      <MobileHeader screen="slots" />

      {selectedCondition && (
        <ConditionCard
          conditionId={selectedCondition?.id}
          title={selectedCondition?.name}
          description={
            selectedCondition?.isDefault
              ? t(
                "Upsell.com displays the default condition when customers do not meet any other condition",
              )
              : selectedCondition?.storeName
          }
          isDisabled={!selectedCondition?.status}
          isConditionOn={selectedCondition?.status || false}
          isSelected={false}
          onClick={() => { }}
          mode={"expand"}
          actions={[]}
          p={2}
          toggleCondition={updateConditionStatus}
          condition={selectedCondition}
          id={"1"}
          dragHandleProps={undefined}
          snapshot={undefined}
          alwaysShowDragHandle={false}
          fromMobileHeader={true}
        >
          <ConditionTextContainer
            con={selectedCondition}
            mouseRef={mouseRef}
            formatCurrency={formatCurrency}
          />
        </ConditionCard>
      )}

      <Box flex={1} minH={0} overflowY="auto" px="5px" mt="8px" pb="4px">
        <Slots />
      </Box>
    </Box>
  );
};

export default MobileSlotsScreen;
